import { InformationCircleIcon } from "@heroicons/react/outline";

const NoLabelsMessage = () => (
  <div className="flex flex-col items-center gap-y-2 rounded-lg border border-gray-100 bg-gray-50 p-4 text-center text-sm">
    <InformationCircleIcon className="h-6 w-6 text-gray-500" />
    <div>
      You do not have any available release labels for Prompt Templates.
      <br />
      <a
        href="https://docs.promptlayer.com/features/prompt-registry/release-labels"
        className="text-blue-500 hover:text-blue-600"
      >
        Learn more about release labels on the docs.
      </a>
    </div>
  </div>
);

export default NoLabelsMessage;
